<template>
  <div class="flex flex-col items-stretch">
    <div class="h-2 bg-blue"></div>
    <div class="p-8 font-bold text-blue text-2xl flex flex-row items-center justify-start container mx-auto" style="font-family: 'Raleway', sans-serif">
      <img src="/img/icons/android-chrome-192x192.png" alt="Todoninja Logo" class="h-12 mr-4">
      Todoninja
    </div>

    <div class="p-8 pt-0 mt-16 text-blue-darker">

      <div class="text-center text-4xl">
        <div class="font-bold">
          Get your tasks done.
        </div>
        <div class="font-light mt-4 text-2xl">
          With the brand new <span class="font-bold">do</span> view.
        </div>
      </div>

      <div class="text-center mt-16">
        <a href="https://app.todoninja.de" class="bg-blue shadow-md py-4 px-8 inline-block rounded-lg text-white font-bold ">
          <i class="feather icon-gift mr-4"></i>Start using it now!
        </a>
      </div>

    </div>

    <feature image="/img/screenshot-do.png" class="mt-16" >
      Only the things you can do.

      <div slot="description">
        The do view will only show you the tasks you can get done right in this moment.
      </div>
    </feature>

    <feature image="/img/screenshot-workspaces.png" class="mt-8" background="white" inversed>
      Get rid of lists.

      <div slot="description">
        And say hello to workspaces.
      </div>
    </feature>

    <feature image="/img/screenshot-today.png" class="mt-8" background="blue-lightest">
      Focus on todays tasks!

      <div slot="description">
        You can choose the tasks you want to do today.
      </div>
    </feature>

    <feature image="/img/screenshot-status.png" class="mt-8" background="white" inversed>
      Waiting for someone else?

      <div slot="description">
        Just tell it. This task will not be shown in your do view anymore.
      </div>
    </feature>

    <div class="text-center mt-16">
      <a href="https://app.todoninja.de" class="bg-blue shadow-md py-4 px-8 inline-block rounded-lg text-white font-bold ">
        <i class="feather icon-gift mr-4"></i>Start using it now!
      </a>
    </div>

    <div class="bg-blue-lightest p-16 mt-32">
      <div class="container mx-auto text-center">

        <div>
          Built by <a href="https://owner.todoninja.de" class="link">Sebastian Dittrich</a>
        </div>

        <div class="text-grey-dark uppercase tracking-wide font-bold text-sm mt-16">
          With the the help of
        </div>

        <div class="mt-4">
          <a href="https://pingping.io" class="link">PingPing</a>
        </div>
        <div class="mt-2">
          <a href="https://makerads.xyz" class="link">MakerAds</a>
        </div>
        <div class="mt-2">
          <a href="https://vuejs.org" class="link">Vue JS</a>
        </div>
        <div class="mt-2">
          <a href="https://feathersjs.com" class="link">Feathers JS</a>
        </div>
        <div class="mt-2">
          <a href="https://tailwindcss.com" class="link">Tailwind CSS</a>
        </div>
        <div class="mt-2">
          <a href="https://undraw.co" class="link">Undraw</a>
        </div>
        <div class="mt-2">
          <a href="https://digitalocean.com" class="link">Digital Ocean</a>
        </div>

      </div>
    </div>

  </div>
</template>

<style scoped>
</style>


<script>
import feature from '@/components/feature';

export default {
  name: 'home',
  components: {
    feature,
  },
};
</script>
